export const REGION_HARDWARE_SOURCE_MAP  = {
    NA: [
        { name: "ALL", value: "ALL" },
        { name: "AFEX", value: "AFEX" },
        { name: "SPARROW", value: "SPARROW" },
        { name: "VBI", value: "VBI" },
        { name: "ACHILLES", value: "ACHILLES" },
        { name: "VBIMQty", value: "VBIMQty" },
        { name: "OMNISCAN", value: "OMNISCAN" }
    ],
    EU: [
        { name: "ALL", value: "ALL" },
        { name: "AFEX", value: "AFEX" },
        { name: "VBI", value: "VBI" },
        { name: "ACHILLES", value: "ACHILLES" },
        { name: "VBIMQty", value: "VBIMQty" },
        { name: "OMNISCAN", value: "OMNISCAN" }
    ],
    JP: [
        { name: "ALL", value: "ALL" },
        { name: "VBI", value: "VBI" },
        { name: "ACHILLES", value: "ACHILLES" },
        { name: "VBIMQty", value: "VBIMQty" }
    ]
}

export const REGION_DROPDOWN = [
    { name: "NA", value: "NA" },
    { name: "EU", value: "EU" },
    { name: "JP", value: "JP" }
]

export const ITEM_ID_TYPE_DROPDOWN = [
    { name: "FNSKU", value: "FNSKU" }
]

export const HARDWARE_SOURCE_TO_AFFINITY_THRESHOLD_MAP = {
    ALL: [
        { name: "ALL", value: "ALL" }
    ],
    AFEX: [
        { name: "ALL", value: "ALL" },
        { name: "0.7", value: "0.7" },
        { name: "0.6", value: "0.6" },
        { name: "0.5", value: "0.5" },
        { name: "0.4", value: "0.4" },
        { name: "0.3", value: "0.3" },
        { name: "0.2", value: "0.2" },
        { name: "0.1", value: "0.1" }
    ],
    SPARROW: [
        { name: "ALL", value: "ALL" },
        { name: "0.7", value: "0.7" },
        { name: "0.6", value: "0.6" },
        { name: "0.5", value: "0.5" },
        { name: "0.4", value: "0.4" },
        { name: "0.3", value: "0.3" },
        { name: "0.2", value: "0.2" },
        { name: "0.1", value: "0.1" }
    ],
    VBI: [
        { name: "ALL", value: "ALL" },
        { name: "0.8", value: "0.8" },
        { name: "0.7", value: "0.7" },
        { name: "0.6", value: "0.6" },
        { name: "0.5", value: "0.5" },
        { name: "0.4", value: "0.4" },
        { name: "0.3", value: "0.3" },
        { name: "0.2", value: "0.2" },
        { name: "0.1", value: "0.1" }
    ],
    ACHILLES: [
        { name: "ALL", value: "ALL" },
        { name: "0.7", value: "0.7" },
        { name: "0.6", value: "0.6" },
        { name: "0.5", value: "0.5" },
        { name: "0.4", value: "0.4" },
        { name: "0.3", value: "0.3" },
        { name: "0.2", value: "0.2" },
        { name: "0.1", value: "0.1" }
    ],
    VBIMQty: [
        { name: "ALL", value: "ALL" },
        { name: "0.8", value: "0.8" },
        { name: "0.7", value: "0.7" },
        { name: "0.6", value: "0.6" },
        { name: "0.5", value: "0.5" },
        { name: "0.4", value: "0.4" },
        { name: "0.3", value: "0.3" },
        { name: "0.2", value: "0.2" },
        { name: "0.1", value: "0.1" }
    ],
    OMNISCAN: [
        { name: "ALL", value: "ALL" },
        { name: "0.7", value: "0.7" },
        { name: "0.6", value: "0.6" },
        { name: "0.5", value: "0.5" },
        { name: "0.4", value: "0.4" },
        { name: "0.3", value: "0.3" },
        { name: "0.2", value: "0.2" },
        { name: "0.1", value: "0.1" }
    ],
}

export const HARDWARE_SOURCE_TO_DEFAULT_AFFINITY_THRESHOLD_MAP = {
    AFEX: "0.7",
    SPARROW: "0.7",
    VBI: "0.8",
    ACHILLES: "0.7",
    VBIMQty: "0.8",
    OMNISCAN: "0.7",
}

export const HARDWARE_SOURCE_TO_CANONICAL_SET_MAP = {
    AFEX: "CanonicalSet_Default",
    SPARROW: "CanonicalSet_Sparrow",
    VBI: "CanonicalSet_VBI",
    ACHILLES: "CanonicalSet_Achilles",
    VBIMQty: "CanonicalSet_VBIMQty",
    OMNISCAN: "CanonicalSet_Omniscan",
}

export const HARDWARE_SOURCE_TO_AFFINITY_THRESHOLD_LIST_MAP = {
    AFEX: [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7],
    SPARROW: [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7],
    VBI: [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8],
    ACHILLES: [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7],
    VBIMQty: [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8],
    OMNISCAN: [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7],
}

export const MAX_RESULTS_HELP_MESSAGE = "Max Results is an optional parameter. When this parameter is given as input," +
    " any input for Affinity Threshold is ignored, and it finds the highest Affinity Threshold for which number of" +
    " canonical data <= Max Results and return the canonical data.";

export const AFFINITY_THRESHOLD_HELP_MESSAGE = "Affinity Threshold is a real number in the range of 0 to 1 that" +
    " controls the cluster size and hence the number of canonical representations." +
    " Default value is 0.7 for AFEX and 0.8 for VBI.";
